module.exports = __webpack_public_path__ + "static/media/list.86a11aff.svg";